import {DeclarativeMutationConfig, Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {CreateNovaAgentInput, CreateNovaAgentMutation} from './__generated__/CreateNovaAgentMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// NovaAgentCategory only exposes the relay-encoded `id` (see
// graphql/src/graphql/type/NovaAgentCategoryType.js) — the `agents` connection lives on that
// record, keyed as `NovaStudioCatalogue_agents` on NovaStudioPage_Query's `agents(first: 1000)`
// field. `categoryConnectionParentId` must be that relay `id` (not the raw domain `categoryId`
// on the input), so it is threaded through separately from the GraphQL input.
const mutation = graphql`
	mutation CreateNovaAgentMutation($input: CreateNovaAgentInput!) {
		createNovaAgent(input: $input) {
			agent {
				node {
					id
					name
					title
					description
					shape
					categoryId
				}
			}
		}
	}
`;

function getConfigs(categoryConnectionParentId: string): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_ADD',
			parentID: categoryConnectionParentId,
			connectionInfo: [
				{
					key: 'NovaStudioCatalogue_agents',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'agent',
		},
	];
}

export type CreateNovaAgentMutationInput = MutationInput<CreateNovaAgentInput> & {
	categoryConnectionParentId: string;
};

function commit(
	environment: Environment,
	input: CreateNovaAgentMutationInput,
	onSuccess?: RelayOnCompleted<CreateNovaAgentMutation>,
	onError?: RelayOnError
): Disposable {
	const {categoryConnectionParentId, ...mutationInput} = input;
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...mutationInput}};

	return commitMutation<CreateNovaAgentMutation>(environment, {
		mutation,
		variables,
		configs: getConfigs(categoryConnectionParentId),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
